<app-modal-base
  [title]="'optionalInfo' | translate"
  [showCloseIcon]="true"
  [primaryButtonText]="'confirm' | translate"
  [secondaryButtonText]="'skip' | translate"
  (close)="dialogRef.close(false)"
  (primaryClick)="confirmAction()"
  (secondaryClick)="dialogRef.close(false)"
>
  <div class="space-y-4">
    <div class="flex gap-3 items-center">
      <label class="relative flex items-start [&&]:mb-0">
        <input
          [(ngModel)]="agreedMarketingContact"
          type="checkbox"
          class="peer sr-only remove-default-input-style"
          checked
        />
        <span
          class="flex items-center justify-center h-5 w-5 rounded border border-gray-300 bg-white peer-checked:border-blue-500 peer-checked:bg-blue-500"
        >
          <i class="ph ph-check text-white peer-checked:block"></i>
        </span>
      </label>
      <span class="text-gray-600">
        {{ 'doYouAuthorizeTheSendingOfPromotionalMessages' | translate }}
      </span>
    </div>

    <!-- referred by -->
    <div class="relative flex items-center">
      <select [(ngModel)]="signupReference" class="w-full rounded-lg border p-3 form-input-base">
        <option value="" selected>
          {{ 'REGISTER.tellUsHowDidYouGetToKnow' | translate }}
        </option>
        <option value="social-media">{{ 'REGISTER.socialMedia' | translate }}</option>
        <option value="marketing">{{ 'REGISTER.marketing' | translate }}</option>
        <option value="fairs">{{ 'REGISTER.fairs' | translate }}</option>
        <option value="other">{{ 'REGISTER.other' | translate }}</option>
      </select>
    </div>
  </div>
</app-modal-base>
